<template>
  <div>
    <section id="about-me" class="section" v-if="data.contact_infos">
      <Profile
        v-if="data.contact_infos"
        :name="data.name"
        :avatar="data.avatar"
        :website="'https://github.com/LahoucineABOULHASSAN'"
        :contact="data.contact_infos"
        :beforeEnterH1="beforeEnterH1"
        :enterH1="enterH1"
        :beforeEnterBox="beforeEnterBox"
        :enterBox="enterBox"
        :beforeEnter="beforeEnter"
        :enter="enter"
      />
      <Intro
        v-if="data.about_me"
        :about_me="data.about_me"
        :beforeEnterBox="beforeEnterBox"
        :enterBox="enterBox"
        :beforeEnter="beforeEnter"
        :enter="enter"
      />
      <Albums
        :beforeEnterBox="beforeEnterBox"
        :enterBox="enterBox"
        :beforeEnter="beforeEnter"
        :enter="enter"
      />
    </section>
    <Error
      v-if="error"
      :error="error"
      :beforeEnter="beforeEnter"
      :enter="enter"
    />
  </div>
</template>
<script>
import Intro from "./about/Intro";
import Profile from "./about/Profile";
import Albums from "./about/Albums";
import gsapAnimation from "../composables/gsapAnimation";
import getData from "../composables/getData";
import { Error } from "../components";
export default {
  components: { Intro, Profile, Albums, Error },
  setup() {
    const { data, error, fetchData } = getData(process.env.VUE_APP_PROFILE);
    const {
      beforeEnterH1,
      enterH1,
      beforeEnter,
      enter,
      beforeEnterBox,
      enterBox,
    } = gsapAnimation({ h1: "About Me", y: "100%" });
    fetchData();
    return {
      data,
      error,
      fetchData,
      beforeEnterH1,
      enterH1,
      beforeEnter,
      enter,
      beforeEnterBox,
      enterBox,
    };
  },
};
</script>
